import { platform_dashboard, platform_instructor_details } from "../constants/endpoints";
import { getAuthorizationHeader } from "./repositoryHelper";

const getPlatformDashboard = () => {
  return fetch(platform_dashboard, {
    method: "GET",
    headers: {
      ...getAuthorizationHeader(),
    },
  });
};

const getInstructorsStatistics = () => {
  return fetch(platform_instructor_details, {
    method: "GET",
    headers: {
      ...getAuthorizationHeader(),
    },
  });
};

export const platformDashboardRepository = {
  getPlatformDashboard,
  getInstructorsStatistics,
};
